import React from 'react';
import PropTypes from 'prop-types';
import './WindowToolbar.css';

const WindowToolbar = ({ children }) => {
    return (
        <div className="WindowToolbar">
            <div className="WindowToolbar-border">
                {children}
            </div>
        </div>
    );
};

WindowToolbar.propTypes = {
    children: PropTypes.any
};

export default WindowToolbar;



// WEBPACK FOOTER //
// ./src/components/Browser/WindowToolbar.jsx